import React from 'react'
import Logo from './Logo'
import Navigation from './Navigation';
import Search from './Header/Search';
import HeaderTopRight from './Header/HeaderTopRight';

const Header = () => {
	return (
		<header id="masthead" className="site-header">
			<div className="site-branding">
				<a href="/" rel="home"><Logo/></a>
				<p className="site-title"><a href="/" rel="home">Black Octopus Sound</a></p>
				<p className="site-description"></p>
			</div>
			<Navigation/>
			<Search />
			<HeaderTopRight />
		</header>
	)
}
export default Header